<template>
  <div class="loginAll">
    <div class="login">
      <div class="login_top ovh">
        <div class="f_l login_top_img txt_a_c">
          <span>新增取票人</span>
        </div>
        <div class="f_r close" @click="close()">
          <img src="../../static/close.png" />
        </div>
      </div>
      <!-- 弹框内容 -->
      <div class="frame">
        <!-- 输入框 -->
        <div class="inputAll">
          <input class="input" placeholder="请输入姓名" v-model="name" />
          <input class="input" placeholder="请输入身份证号码" v-model="idCardNum"  />
          <input class="input" placeholder="请输入手机号" v-model="tel" maxlength="11" />
        </div>
        <!-- 按钮 -->
        <div class="button" @click="submit">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
  // 引入共用的css
	import "../components/css/component.css";
  import "../components/css/input.css";

  // 调用的接口
  import {  } from '@/request/api.js';
  import { isIdCard, isMobile } from '@/utils/utils.js'

  export default {
    name: 'addPeople',
    data () {
      return {
        name: '', // 姓名
        idCardNum: '', // 身份证号码
        tel: '' // 手机号
      }
    },

    mounted() {
      
    },

    methods:{
      // 进入页面执行的操作
      init() {
        
      },

      // 点击确定按钮
      submit() {
        if (!isIdCard(this.idCardNum)) {
          this.$message({
            showClose: true,
            message: '身份证格式错误'
          });
          return
        }
        if (!isMobile(this.tel)) {
          this.$message({
            showClose: true,
            message: '手机号格式错误'
          });
          return
        }
        // 关闭弹框
        this.close();
      },

      // 关闭弹框
      close() {
        // 执行父组件的方法
        this.$emit('addPeopleReturn', this.name, this.idCardNum, this.tel)
      }
    }
  }
</script>

<!-- 样式 -->
<style scoped lang="scss">
  .loginAll {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0,0,0,.5);
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    // 框
    .login {
      width: 644px;
      height: 456px;
      background-color: #FFFFFF;
      border-radius: 8px;
      &> .login_top {
        height: 70px;
        lin-height: 70px;
        background-color: #FF7702;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        padding: 0 16px;
        &> .login_top_img {
          // width: 565px;
          height: 70px;
          line-height: 70px;
          font-size: 23px;
          padding: 0 0 0 246px;
          box-sizing: border-box;
          font-weight: bold;
          color: #fff;
          letter-spacing: 1px;
        }
        &> .close {
          width: 24px;
          height: 24px;
          font-size: 25px;
          line-height: 70px;
          margin-top: 3px;
          cursor: pointer;
        }
      }
      // 框
      &> .frame {
        width: 344px;
        margin: 0 auto;
        padding: 0 0 0 0;
        // tab选项
        &> .tabListAll {
          &> .tabList {
            width: 50%;
            font-size: 18px;
            font-weight: 400;
            font-family: PingFangSC-Regular, PingFang SC;
            letter-spacing: 1px;
            cursor: pointer;
            color: #BFC0C0;
            // tab下划线选中
            &> .tabList_select {
              width: 80px;
              height: 4px;
              background: #0F7DFF;
              border-radius: 2px;
              margin: 5px auto;
            }
          }
          &> .tabListSelect {
            color: #434444;
          }
        }
        // 隐私协议
        &> .agreement {
          width: 100%;
          margin-top: 28px;
          &> .checkbox {
            margin: 2px 8px 0 0;
          }
          &> .agreementTxt {
            font-size: 12px;
            color: #7F7E7D;
            & span {
              color: #0F7DFF;
            }
          }
        }
        // 按钮
        &> .button {
          color: #fff;
          background-color: #0F7DFF;
          width: 344px;
          height: 56px;
          line-height: 56px;
          border-radius: 8px;
          margin: 70px 0 0 0;
        }
        // 注册
        &> .bottom_size {
          text-align: center;
          line-height: 40px;
          color: #0F7DFF;
          letter-spacing: 1px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
        }
      }
    }
  }
  .input {
    font-size: 14px;
    width: 310px;
    height: 56px;
    line-height: 56px;
    border-radius: 8px;
    background: #E2E2E2;
    padding: 0 17px;
    // box-sizing: border-box;
    letter-spacing: 1px;
    margin-top: 22px;
  }
  .input_code {
    width: 50%;
    height: 56px;
    line-height: 56px;
    font-size: 14px;
    letter-spacing: 1px;
  }
  .input_time {
    width: 80px;
    color: #0F7DFF;
  }
  input {
    -webkit-text-fill-color: #434444;
  }
</style>



// WEBPACK FOOTER //
// src/page/addPeople.vue